import { useMemo } from 'react'
import { useAbsoluteRouteMatch } from '../routing/useAbsoluteRouteMatch.hooks'
import { usePartnerId, useRetailerId, useStoreConfigId } from '../routing/params.hooks'
import { useCurrentAccountContext } from '../current-account/CurrentAccountContext'
import { useCurrentAccountDetails } from '../../api/current-account/currentAccount.hooks'
import { trackEvent, type TrackedEvent } from './trackEvent'

// This hooks fetches account from the CurrentAccountDetails, which is a lot
// more expensive and only be used in fringe areas of IPP where we are not wrapped
// with the CurrentAccountProvider.
export const useTrackEventSafe = () => {
  const { account } = useCurrentAccountDetails()
  return useTrackEventCommon(account)
}

// This hook grabs account from the CurrentAccountContext, and should be used 99% of the time
export const useTrackEvent = () => {
  const { account } = useCurrentAccountContext()

  return useTrackEventCommon(account)
}

export const useTrackEventCommon = account => {
  const partnerId = usePartnerId({ throwOnMissing: false })
  const retailerId = useRetailerId({ throwOnMissing: false })
  const storeConfigId = useStoreConfigId({ throwOnMissing: false })
  const sanitizedUrlPath = useAbsoluteRouteMatch()?.pathName

  const trackEventWithStandardData = useMemo(
    () =>
      ({ id, description, data }: TrackedEvent) =>
        trackEvent({
          id,
          description,
          data: {
            partnerId,
            retailerId,
            storeConfigId,
            canonicalId: account?.canonicalId,
            isInternal: account?.isInternal,
            sanitizedUrlPath,
            ...data,
          },
        }),
    [
      partnerId,
      retailerId,
      storeConfigId,
      account?.canonicalId,
      account?.isInternal,
      sanitizedUrlPath,
    ]
  )

  return trackEventWithStandardData
}
